<template>
    <div :id="id" :class="backgroundColor ? 'bg-' + backgroundColor : null">
        <slot name="full-width" />

        <slot name="container">
            <div class="container relative">
                <div :class="slotClass">
                    <slot />
                </div>

                <BlockDividerArrow
                    v-if="arrowCallout"
                    :arrow-callout="arrowCallout"
                    class="absolute z-20"
                    :class="dividerArrowClass"
                />
            </div>
        </slot>

        <BlockBottomAngle
            v-if="bottomAngle"
            class="hidden md:block"
            :bottom-angle="bottomAngle"
            :bg-color="backgroundColor || 'white'"
            :bottom-angle-bg-color="angleBackgroundColor || 'white'"
        />
    </div>
</template>

<script setup lang="ts">
import type { ArrowCalloutType } from '#shared/types/ArrowCalloutType';
import BlockDividerArrow from '~/components/BlockDividerArrow.vue';
import BlockBottomAngle from '~/storyblok/components/BlockBottomAngle.vue';

interface Props {
    id?: string | undefined;
    backgroundColor: string | null;
    bottomAngle?: string | null;
    angleBackgroundColor?: string | null;
    arrowCallout?: ArrowCalloutType | null;
    dividerArrowClass?: string | null;
    slotClass?: any;
}

defineProps<Props>();
</script>
